/**
 * Maps API rating keys to the numeric index used by the Rating component.
 *
 * The Rating component expects a 0-3 index corresponding to:
 *   0 = "Skip It"
 *   1 = "Okay"
 *   2 = "Try It"
 *   3 = "Must Try"
 */

const RATING_KEY_TO_INDEX: Record<string, number> = {
  not_for_me: 0,
  okay: 1,
  try_it: 2,
  must_try: 3,
};

export function ratingKeyToIndex(key: string): number | null {
  return RATING_KEY_TO_INDEX[key] ?? null;
}
